// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"de7814e0","425":"32d77847","510":"4819d024","532":"414d80e7","633":"fd5eeddb","634":"9340aa08","922":"da9fe50b","937":"c6a32bbc","972":"c7c4e6d0"}[chunkId] + ".chunk.js";
};